/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StatusCategory from './StatusCategory';

/**
 * The JobStatus model module.
 * @module model/JobStatus
 * @version V1
 */
class JobStatus {
    /**
     * Constructs a new <code>JobStatus</code>.
     * @alias module:model/JobStatus
     */
    constructor() { 
        
        JobStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobStatus} obj Optional instance to populate.
     * @return {module:model/JobStatus} The populated <code>JobStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobStatus();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('statusCategoryID')) {
                obj['statusCategoryID'] = StatusCategory.constructFromObject(data['statusCategoryID']);
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobStatus</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobStatus</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
JobStatus.prototype['id'] = undefined;

/**
 * @member {String} name
 */
JobStatus.prototype['name'] = undefined;

/**
 * @member {module:model/StatusCategory} statusCategoryID
 */
JobStatus.prototype['statusCategoryID'] = undefined;

/**
 * @member {Number} accountId
 */
JobStatus.prototype['accountId'] = undefined;

/**
 * @member {Date} createdAt
 */
JobStatus.prototype['createdAt'] = undefined;






export default JobStatus;

